<!--
 * @Description: 
 * @Date: 2020-09-29 17:48:09
-->
<template>
  <div class="stop">
    <img src="../../static/img/warning.png" />
    <p>{{text.desc}}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: {
        '-995': { title: '专区已被停用', desc: '该专区已被停用，暂时无法访问' },
        '-994': { title: '专区已被删除', desc: '该专区已被删除，暂时无法访问' },
        '-993': { title: '该内容已下架', desc: '该内容已下架，暂时无法查看' },
        '-992': {
          title: '该详情已下架或已删除',
          desc: '该详情已下架或已删除，暂时无法查看'
        }
      }
    };
  },
  components: {},
  watch: {},
  computed: {
    text() {
      return this.map[this.$route.query.type] || {};
    }
  },
  methods: {},
  created() {
    document.title = this.text.title;
  },
  beforeDestroy() {}
};
</script>

<style scoped lang='scss'>
.stop {
  text-align: center;
  margin-top: 3.52rem;
  img {
    width: 2.67rem;
    height: 2.67rem;
    margin-bottom: 0.43rem;
  }
  p {
    font-size: 0.43rem;
    color: rgba(50, 50, 53, 1);
    line-height: 0.43rem;
  }
}
</style>
